export default "__VITE_ASSET__BDLbclIV__"